"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.resetDamageAreas = exports.deleteManyDamageAreas = exports.deletedOneDamageArea = exports.updatedManyDamageAreas = exports.updatedOneDamageArea = exports.gotManyDamageAreas = exports.gotOneDamageArea = void 0;
var index_1 = __importDefault(require("./index"));
var _a = index_1.default.actions, gotOne = _a.gotOne, gotMany = _a.gotMany, updatedOne = _a.updatedOne, updatedMany = _a.updatedMany, deletedOne = _a.deletedOne, deleteMany = _a.deleteMany, reset = _a.reset;
exports.gotOneDamageArea = gotOne;
exports.gotManyDamageAreas = gotMany;
exports.updatedOneDamageArea = updatedOne;
exports.updatedManyDamageAreas = updatedMany;
exports.deletedOneDamageArea = deletedOne;
exports.deleteManyDamageAreas = deleteMany;
exports.resetDamageAreas = reset;
//# sourceMappingURL=actions.js.map